'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider-hoc');

const MainContent = require('./exclusive-main-content');
const SideBar = require('./exclusive-sidebar');
const Footer = require('../../../components/footer');

function getElements({
  isTouch,
  couponsForList,
  routes,
  advertsForCarousel,
  csrfToken,
}) {
  const mainContentElement = MainContent({ couponsForList, routes });
  const sidebarElement = SideBar({
    advertsForCarousel,
    routes,
    csrfToken,
    isTouch,
  });

  if (isTouch) {
    return [h('.twelve.column', [mainContentElement, sidebarElement])];
  }

  return [
    h('.nine.column.push-three', mainContentElement),
    h('.three.column.pull-nine', sidebarElement),
  ];
}

function ExclusiveOffers({ payload, deps }) {
  const {
    seoMetaData: { h1Override },
    navigationMerchants,
    couponsForList,
    advertsForCarousel,
  } = payload;
  const { routes, csrfToken, isTouch } = deps;

  return h('article.wrapper-page', [
    h(RedemptionProvider, { routes }),
    h(Header, {
      routes,
      activePage: 'exclusive-offers',
      merchants: navigationMerchants,
      titleText: h1Override,
      resourceKey: 'modules.exclusive_offers.PageHeading',
    }),
    h(
      'section.page-container',
      h(
        '.row',
        ...getElements({
          isTouch,
          couponsForList,
          routes,
          advertsForCarousel,
          csrfToken,
        }),
        h('.twelve.column', Footer())
      )
    ),
  ]);
}

module.exports = ExclusiveOffers;
